export default __webpack_public_path__ + "static/media/QuestionMark.b6cd8700.svg";